export enum MapConstants {
  /**
   * Interval in which current position will be fetched
   *
   * (in milliseconds)
   */
  CURRENT_POSITION_FETCH_INTERVAL = 9000,   //9 sec
  /**
   * Fence radius around a geo location position.
   * To be used as a threshold value for IN/OUT transition in the fence
   *
   * (in meters)
   */
  FENCE_RADIUS_GROUND = 350, //350 meter
  FENCE_RADIUS_AIR = 2000, //2 km
  /**
   * Time duration after which if the current position doesn't changes,
   * it will be considered to be on HOLD state (not moving)
   *
   * Should be greater than or equal to `CURRENT_POSITION_FETCH_INTERVAL`
   *
   * (in milliseconds)
   */
  POSITION_HOLD_TIME_THRESHOLD = 60000,  //1  minute
  /**
   * Distance after which if the current position doesn't changes,
   * it will be considered to be on HOLD state (not moving)
   *
   * (in meters)
   */
  POSITION_HOLD_DISTANCE_THRESHOLD = 20,  //20 meter
  /**
   * 
   * Max Time duration to hold
   * (in miliseconds)
   */
  POSITION_HOLD_LIMIT = 120000  // 2 minute
}

export enum FenceTransitionType {
  ENTER = "ENTER",
  EXIT = "EXIT",
  NONE = "NONE",
}

export enum DriverLocation {
  SOURCE = "SOURCE",
  DESTINATION = "DESTINATION",
  NONE = "NONE"
}

export enum GeoTrackingEvents {
  SOURCE_ENTERED = "SOURCE_ENTERED",
  SOURCE_EXITED = "SOURCE_EXITED",
  DESTINATION_ENTERED = "DESTINATIONE_ENTERED",
  DESTINATION_EXITED = "DESTINATIONE_EXITED"
}
